var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4",attrs:{"outlined":""}},[_c('app-md',[_vm._v(" "+_vm._s(_vm.migration || ' ')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }